import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@ui/components/ui/dialog';
import { Button } from '@ui/components/ui/button';
import { Incident } from './sources/incidents';

/** Closing an incident. It asks nothing: a dialog only because closing takes it off the queue. */
const IncidentCloseDialog = ({
  incident,
  onClose,
  onCancel,
}: {
  incident: Incident | null;
  onClose: () => void;
  onCancel: () => void;
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={!!incident} onOpenChange={open => !open && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('incidents.closeTitle')}</DialogTitle>
          <DialogDescription>{incident?.title}</DialogDescription>
        </DialogHeader>

        {/* What closing costs, rather than leaving it to be discovered by a later entry being refused. */}
        <p className="text-sm text-muted-foreground">{t('incidents.closeMeaning')}</p>

        <DialogFooter>
          <Button variant="ghost" onClick={onCancel}>
            {t('actions.cancel')}
          </Button>
          {/* "Close it", not "Close": the dialog's own X is already named Close. */}
          <Button onClick={onClose}>{t('incidents.closeConfirm')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default IncidentCloseDialog;
